import { Button } from '@radix-ui/themes';
import { Root as Form, Submit } from '@radix-ui/react-form';
import { Controller, useForm } from 'react-hook-form';

import { COOKIE_FUNCTIONAL_FIELD_NAME } from '@/constants/client/field-names';
import { SwitchField } from '@/components/forms/Switch';

const i18n = {
  en: {
    fields: {
      cookiesEssential: {
        label: 'Essential Cookies',
        description: 'These cookies are required for the website to function.',
      },
    },
    actions: {
      submit: 'Save',
    },
  },
};

interface CookiesInput {
  [COOKIE_FUNCTIONAL_FIELD_NAME]: boolean;
}

export default function CookieSettingsForm({
  onSubmit,
}: {
  onSubmit: (values?: NonNullable<CookiesInput>) => void | Promise<void>;
}) {
  const { control, handleSubmit } = useForm<CookiesInput>({
    defaultValues: {
      [COOKIE_FUNCTIONAL_FIELD_NAME]: true,
    },
  });

  return (
    /* @ts-ignore */
    <Form
      onSubmit={handleSubmit(onSubmit)}
      className="flex h-full flex-col justify-between gap-10"
    >
      <Controller
        name={COOKIE_FUNCTIONAL_FIELD_NAME}
        control={control}
        render={({ field }) => (
          <SwitchField
            disabled
            defaultChecked={true}
            name={COOKIE_FUNCTIONAL_FIELD_NAME}
            label={i18n.en.fields.cookiesEssential.label}
            description={i18n.en.fields.cookiesEssential.description}
            onChange={(checked) => field.onChange(checked)}
          />
        )}
      />

      <Button type="submit" size="3" asChild disabled>
        <Submit>{i18n.en.actions.submit}</Submit>
      </Button>
    </Form>
  );
}
